
import PageHeader from "../components/PageHeader";
import "../css/commontemplate.css";
import { shriDajiMahaImg } from "../assets/assets.js"; // assets.js images

export default function DajiMah() {
  return (
    <>
      <PageHeader
        title="श्रीदाजीमहाराज"
        path="/dajiMah"
        name=" Daji maharaj"
      />
      {/* <DynamicContentComponent content={dajimah} heading={"श्रीदाजीमहाराज विषयी माहिती"} /> */}

      <div className="comman-template-section">
        <h1 className="comman-template-section-title">
          श्रीसद्गुरु वेंकटेश दाजीमहाराज जीवन व कार्य
        </h1>

        <div className="comman-template-container">
          {/* container  */}

          <div className="comman-template-sub-section">
            <div className="comman-template-info-container">
              {/* info container */}
              <h3> पार्श्वभूमी  </h3>
              {/* <div className="comman-template-info-container-shlok">
                  मातरःसर्वभूताना गाव : सर्वसुखप्रदाः
                </div> */}
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; प्राचीन भारतीय संस्कृती
                विश्ववंदनीय, ख्यातीप्राप्त आहे. तपस्वी, ऋषीमुनी, लोककल्याणकारी 
                थोर साधुसंत, आचार्य, तत्त्वज्ञ आदींची महान परंपरा सर्वश्रुत आहे.
                सामाजिक, सांस्कृतिक, धार्मिक, आध्यात्मिक, आरोग्य, खगोलविज्ञानआदी
                संशोधनात्मक शास्त्रे इत्यादी क्षेत्रातील भारतीयांचे अनादी
                कालापासूनचे सक्रिय योगदान लक्षणीय राहिले.
                उज्ज्वल भारतीय परंपरा संरक्षित व संवर्धित व्हावी, समृद्ध व
                संपन्न व्हावी, याचा सातत्याने प्रयत्न होत राहिला.
              </p>
           
            </div>
          </div>

          <div className="comman-template-sub-section">
            <div className="comman-template-img-container">
              <img
                className="comman-template-image"
                src={shriDajiMahaImg.d_img01}
                alt=""
              />
              {/* <div className="comman-template-image-caption">some text we have put here for the image caption in the future some text we have put here </div> */}
            </div>
            <div className="comman-template-info-container">
              {/* info container */}
              <center>
                {" "}
                <h3> संत परंपरा </h3>
              </center>
              {/* <div className="comman-template-info-container-shlok">
                  मातरःसर्वभूताना गाव : सर्वसुखप्रदाः
                </div> */}
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; महाराष्ट्र ही संतांची भूमी आहे.
                संतश्रेष्ठ ज्ञानेश्वरांनी भागवत धर्माचा-वारकरी संप्रदायाचा
                पाया रचला. संत नामदेव, संत एकनाथ यांनी त्याला भक्कम आधार दिला.
                तर संत तुकाराम या भागवत संप्रदायरुपी इमारतीचा कळस ठरले. संत
                बहिणाबाईंनी त्यावर पताका फडकावली. संत गोरोबाकाका,जनार्दनपंत,
                सावता माळी, चोखोबा राय, नरहरी महाराज, जनाबाई, मुक्ताबाई, निवृत्तीनाथ, सोपान काका, सोयराबाई, विसोबा खेचर, परिसर भागवत,
                सेना न्हावी, कानोपात्रा, संत निळोबाराय इत्यादी संत मंडळी या
                मांदियाळीत होती.एवढेच नव्हे तर देगलूरचे संत चुडामणी ,भालकीचे
                श्री शुकानंद, कंधारचे साधू महाराज, लोणीचे सखाराम महाराज इत्यादी
                या भागातील संतांची कार्य परंपराही उल्लेखनीय होय.
              </p>
            </div>
          </div>

          {/* balpan  */}
          <div className="comman-template-sub-section">
            <div className="comman-template-img-container comman-template-img-container-right">
              <img
                className="comman-template-image"
                src={shriDajiMahaImg.d_img03}
                alt=""
              />
               {/* <div className="comman-template-image-caption">some text we have put here for the image caption in the future some text we have put here </div> */}
            </div>
            <div className="comman-template-info-container">
              <center>
                {" "}
                <h3>जन्म व बालपण</h3>
              </center>
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; महाराष्ट्राच्या संत परंपरेतील
                रिद्धी-सिद्धीप्राप्त एक वैदिक संत म्हणून श्रीसद्गुरू वेंकटेश
                दाजीमहाराज यांचा नावलौकिक आहे.पंचक्रोशीत नाथसंप्रदायाचे योगीराज
                श्रीगंगाजीबापूमहाराज,महंत गैबीबुवा,ऋषीमुनी मार्कंडेय,महंत सद्गिर
                महाराज, सुफी संत हजरत मस्तान शाहवली, लासिना मठाधिपती
                श्रीगुरुबुध्दी स्वामी इत्यादी संतांच्या मांदियाळीने'
                लक्ष्मीवना' चे माहात्म्य वाढविले.
              </p>
              <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; मराठवाड्यातील परभणी जिल्ह्यात परमपवित्र गोदावरीकाठी वसलेले धनगर
                टाकळी हे खेडेगाव. येथे धनगर समाजाची वसती अधिक असून एकेकाळी 'घोंगडी' साठी प्रसिद्ध असलेले हे गाव.गोदावरी नदीचे पात्र येथे
                चंद्राकार स्वरूपाचे असल्याने हे एक सिद्धपीठ मानले जाते. या
                निसर्गदत्त सिद्धपीठाच्या पावन भूमीत श्रीसद्गुरू दाजीमहाराज
                अवतरले. वेदोनारायणाची उपासना करणाऱ्या एका गरीब,सामान्य वैदिक
                कुटुंबात भारतीय कालगणनेनुसार मिती पौष शुद्ध द्वादशी शके 1784
                (इंग्रजी कालगणनेनुसार रविवार, ता.12 जानेवारी 1862) रोजी त्यांचा
                जन्म झाला. वडील लक्ष्मणराव थोर गायत्रिभक्त,वेदशास्त्रसंपन्न तर
                आई रुक्मिणीदेवी सदाचरणी भगवद्भक्त. नवजात बालकाचे 'वेंकटेश' असे
                नामाभिधान करण्यात आले.मात्र कालौघात हा सिद्ध - योगेश्वर कुलदीपक
                'दाजी' या नावाने सुपरिचित झाला.'महाराज' हे उपपद लागले
              </p>
              <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  सर्वसामान्य कुटुंबातल्या प्रमाणेच दाजींचे बालपण मोठ्या
                कोडकौतुकात गेले.पाच वर्षे पूर्ण होताच त्यांचे व्रतबंधन व्हावे
                म्हणजे विद्योपासनेचा मार्ग सुलभ होईल,अशी इच्छा पिता
                लक्ष्मणशास्त्री यांनी व्यक्त केली. दुर्दैवाने वडिलांचे निधन
                झाले.सारे कुटुंब दुःखमग्न झाले.त्यांच्या कार्यकाळात दाजीच्या
                उपनयन संस्काराची इच्छा अपूर्णच राहिली;मात्र या शोक प्रसंगी
                योगैश्वरबलाने प्रगटून योगीराज श्रीगंगाजीबापू यांनी कुटुंबीयांचे
                सांत्वन केले. "वेंकटेश" साक्षात योगी, भाग्यवंत असून जगदोद्घार
                करेल,त्याचा सांभाळ करावा" अशी भविष्यवाणी वर्तवली. कालांतराने
                त्या दिव्यानुभुतीची प्रचीती सर्वांना होत राहिली.
              </p>
              <center>
                {" "}
                <div className="comman-template-info-container-shlok">
                  ज्येष्ठभ्राता पितु: समान
                </div>
              </center>
              <p>
                {" "}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;या उक्तीनुसार सात वर्षे पूर्ण होताच बंधू श्री विठ्ठलअप्पा यांनी
                दाजीचा उपनयन संस्कार सोहळा मोठ्या थाटामाटात संपन्न
                केला.श्रीगंगाजीबापू यांच्यासह वैदिकवर,आप्तस्वकीय स्नेही मंडळींची
                आशीर्वादपर उपस्थिती लाभली. वेदमूल गायत्रीमातेची उपासना बटू
                'दाजी' नी सुरु केली. आजन्म ती कायम राहिली.
              </p>{" "}
              <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; स्वगृही व दशग्रंथी वैदिक परशुराम भट्ट यांच्या गुरुगृही दाजी
                महाराज यांच्या शिक्षणाचा 'श्रीगणेशा' झाला. गंगास्नान, त्रिकाल
                संध्या,गायत्री जप,वेदाध्ययन असा नित्यपाठ कष्टपूर्वक अखंडितपणे
                तपोपूर्तीपर्यंत सुरु राहिला. विद्योपासनेच्या कार्यकाळातच श्रीदाजीमहाराजांनी तपोनिधी श्रीशुकानंद यांचे शिष्य श्री. कृष्णराव
                सरदेशपांडे (नांदेड) यांना आपल्या दिव्य ज्ञानाचा प्रत्यय घडवून
                आणत शांकर-शाक्त शक्तीच्या एकात्म परंपरेचे रक्षण केले.
              </p>
              <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; भारतात वेदांचे दक्षिणपीठ मानल्या जाणाऱ्या श्रीक्षेत्र ज्योतिर्लिंग परळी वैजनाथ येथे घनपाठी दशग्रंथी व शिवभक्त
                शिवरामभट्ट यांच्याकडे क्रमांतपाठपर्यंतचे शिक्षण पूर्ण केले.
                महाराज दशग्रंथी, घनपाठी वेदाग्रणी बनले.संत जनाबाईंच्या
                पदस्पर्शाने पुनीत झालेल्या व श्री चिंतामणीचा वरदहस्त लाभलेल्या
                श्रीक्षेत्र गंगाखेड येथे गुरुवर्य वैष्णवाचार्य यांच्याकडे
                त्यांनी वेदांग ज्योतिष, ग्रहलाघव्यादी अध्ययन केले.
              </p>
              <center>
                <div className="comman-template-info-container-shlok">
                  गोदा असे ज्येष्ठ बहीण, 
                  भागीरथीचे कनिष्ठपण | <br />
                  गोदातट श्रेष्ठ विद्यापीठ जाण, 
                  व्हावे प्रतिष्ठान वेदांचे ||
                </div>
              </center>
              <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  या प्रबळ ध्येयाने त्यांनी आपली जन्मभूमी धनगर टाकळी हीच कर्मभूमी
                बनवली. 'श्री दाजीगुरुंची टाकळी' असा गौरव गावाला प्राप्त झाला.
              </p>
            </div>
          </div>

          {/* jkdnfjksdjd */}
          <div className="comman-template-sub-section">
                      {/* sub-section */}
                      <div className="comman-template-img-container">
                       
                        <img
                          className="comman-template-image"
                          src={shriDajiMahaImg.d_img04}
                          alt=""
                        />
                         {/* <div className="comman-template-image-caption">some text we have put here for the image caption in the future some text we have put here </div> */}
                      </div>
                      <div className="comman-template-info-container">
                        {/* info container */}
                         <h3>कौटुंबिक पार्श्वभूमी</h3>
                       
                        <p>
                        &nbsp;  &nbsp;  &nbsp; &nbsp;   &nbsp; &nbsp;
                        श्रीसद्गुरू दाजीमहाराज यांची कौटुंबिक पार्श्वभूमी लौकिकार्थाने सर्वसामान्य व्यक्तींप्रमाणेच आहे.ग्रामीण भागातील पोटापुरती शेती-भाती असलेलं व वैदिक पौरोहित्य परंपरेतून उदरनिर्वाह करीत असलेलं हे एकत्रकुटुंब पद्धतीचं सत्शील कुटुंब... वशिष्ठ गोत्री आश्वलायन शाखा ऋग्वेदी ब्राह्मण कुटुंबातील लक्ष्मणशास्त्री व वात्सल्यमूर्ती रुक्मिणीदेवी हे दाम्पत्य या कुटुंबाचे प्रमुख.या दांपत्यास ज्येष्ठपुत्र 'विठ्ठल' तर द्वितीय पुत्र 'वेंकटेश' हे दोन पुत्ररत्न होते. संतुष्टवृत्तीने गृहस्थधर्माचं सात्विक आचरण हाच या कुटुंबाचा स्थायीभाव.
                        </p>
                        <p>
                        &nbsp;  &nbsp;  &nbsp; &nbsp;   &nbsp; &nbsp;
                        त्रिकालसंध्या ,गंगास्नान,गायत्री जप व पंचयज्ञाची नित्योपासना, वेदांचे अध्ययन-अध्यापन हा वेदशास्त्रसंपन्न लक्ष्मणशास्त्री यांचा नित्यक्रम. हा पैतृक वारसा जोपासताना दाजीगुरुंच्या मनात तपोभूत साधना व त्यागवृत्तीने निरीच्छपणे जगत्कल्याण कार्याची ओढ निर्माण होऊ लागली.
                        </p>
                        <p>
                        &nbsp;  &nbsp;  &nbsp; &nbsp;   &nbsp; &nbsp;
                        श्रीदाजीमहाराज यांचे वय सोळा वर्षे पूर्ण झाले.विवाहास अनुकूल ही वयोवस्था लक्षात घेऊन माता रुक्मिनिदेवीने विठ्ठलअप्पास दाजीसाठी योग्य स्थळ पाहण्यास सुचविले. त्याचा योग लवकरच जुळला. पंचक्रोशीतील वझूर गावच्या जोशी कुटुंबातील कन्येशी दाजीमहाराज विवाहबद्ध झाले.दुर्दैवाने अवघ्या दोन वर्षातच त्यांची पत्नी 'देवाघरची पाहुणी' झाली. सर्व कुटुंब हळहळले.शोकाकुल माता रुक्मिणी देवी न्यायनिष्ठुर नियतीला दोष देत अत्यंत व्याकुळपणे मनोमन दाजींच्या सांसारिक जीवनाची मनोकामना व्यक्त करीत होत्या.त्यांची शोकमग्न विमनस्क अवस्था पाहून मातृभक्त दाजीनी द्वितीय विवाहास संमती दिली. वसमतनगरीच्या वेद विद्या ज्योतिष पारंगत निळू नागेश भट्ट यांच्या कन्येशी (सोनू) विवाह सुनिश्चित झाला.मिती माघ वद्य अष्टमी शके 1803 (सोमवार, दि.21 फेब्रुवारी 1881) सुमंगल मुहूर्तावर बोधानंद मठात शुभविवाह संपन्न झाला. यावेळी श्री शुकानंद संस्थानचे अधिपती तपोमुर्ती लक्ष्मीशानंद स्वामी,योगीराज श्री गंगाजी बापू महाराज या योगिद्वयांची विवाहास आशीर्वचनपर उपस्थिती दोन्ही कुटुंबीयांसाठी आनंद द्विगुणित करणारी होती.सासरी श्री लक्ष्मी पूजन प्रसंगी नववधूला 'पार्वती' हे नामाभिधान प्राप्त झाले. महाराजांचा 'विश्वकुटुंबी' संसार सुरू झाला. त्याचे 'श्रीदाजीगुरुदर्शन' या चरित्र ग्रंथात- 
                        </p>
                       <center>
                       <div className="comman-template-info-container-shlok">
                        धन्य गृहस्थाश्रमी सर्वोत्तम l योगिश्वर सार्वभौम l<br /> 
                        झाले निष्काम टाकळी ग्राम l पवित्र धाम गोदातीरी ll
                           </div>
                       </center>
                        <p>
                        &nbsp;  &nbsp;  &nbsp; &nbsp;   &nbsp; &nbsp; अशा समर्पक शब्दांत वर्णन केले आहे.
                        श्रीदाजीमहाराज यांना 'राजेश्वर' उपाख्य भाऊ महाराज, 'रामशास्त्री'  व 'सिद्धमहाराज' असे तीन पुत्र व कन्या गुजाई अशी चार अपत्ये होती.सिद्धयोग सामर्थ्य संपन्न भाऊ महाराज यांची जन्म कथा अलौकिक मानली जाते.त्यांच्या जन्माच्या अवघ्या तिसऱ्या दिवशी त्याची प्रचीती आली होती.  ऋग्वेद संहिता पदक्रम, ज्योतिष, धर्मशास्त्र आदींचे व्यासंगपूर्ण अध्ययन त्यांनी पूर्ण केले.वाराणसीच्या (काशी) श्री विश्वेश्वराच्या समोर काशीच्या वैदिकांबरोबर मंत्रजागरात बालवीर साधक भाऊ महाराज सरस ठरले.शारदापीठाधिश्वरांनी वैदिक अग्रणी भाऊचा यथोचित विजयपत्र देऊन गौरविले.त्रिकालज्ञानी श्रीदाजी महाराजांना मनोमन अत्यानंद झाला. तरी अंतर्यामी ते विधिलिखित जाणत होते. भाऊंना त्यांनी त्याची सूचकपणे कल्पनाही दिली.एक उत्तम योजक म्हणूनही भाऊ महाराज यांचे व्यवस्थापन कौशल्य श्रीमद् जगद्गुरु शंकराचार्य यांचा श्री क्षेत्र धनगर टाकळी येथे चाललेला चातुर्मास व भव्य यज्ञ आयोजन प्रसंगी प्रत्ययास आले. संजीवनीविद्याप्राप्त भाऊ महाराज मात्र अल्पायुषी ठरले. त्यांची पत्नी रमाबाईंनी संस्थानातील भाविक,सद्गुरुभक्त,कुटुंबीय,आप्तस्वकीय,अभ्यागतांची आजन्म अविरतपणे आत्मीयतेने वात्सल्यपूर्वक सेवा केली.
श्रीदाजीमहाराजांचे द्वितीय पुत्र रामशास्त्री यांना श्री परशुराम भट्ट यांनी दत्तकपुत्र म्हणून स्वीकारले. तृतीयपुत्र सिद्ध महाराज यांनी पैतृक वारसा जोपासला.
                        </p>
                        <p>
                        दाजीमहाराजांनी गृहस्थधर्म निभावला.त्याचवेळी प्रपंच आणि परमार्थ यांची योग्य सांगड घातली.या दोहोंचा एकात्म मनोज्ञ संगम म्हणजे दाजीमहाराजांचे जीवन, हे विशेषत्वाने नमूद करावे लागते.
                        </p>
                        <p>
                        संसार म्हटलं की, सुख दुःख आलेच.<b style={{color:'red'}}>" भोक्तव्य  हे भोगूनच संपवलं पाहिजे"</b >,अशी दाजीमहाराजांची जीवन धारणा होती. त्यांच्या या जीवन निष्ठेला महामहोपाध्याय श्री. यज्ञेश्वरशास्त्री कस्तुरे गुरुजी यांनी  <b style={{color:'red'}}>"साम्यस्थिती"</b>असे संबोधले आहे.
                        </p>
                      </div>
                    </div>
        </div>
      </div>

    </>
  );
}
